import React from 'react';
import type { IconProps } from '../types';

// Circle status indicator (for account status)
export const IconCircleDemo: React.FC<IconProps> = ({ size = 12, className = '', color = '#10b981' }) => (
  <svg width={size} height={size} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <circle cx="6" cy="6" r="5" fill={color}/>
  </svg>
);
